<template>
    <section v-if="page" class=" border bg-cover bg-center flex items-center min-h-screen bg-orange-300"
        :class="'text-' + (page?.meta.textcolor || 'black') + ' ' + (page.class || '')"
        :style="page?.image ? { backgroundImage: `url(${bgImageUrl})` } : {}">
        <UContainer class="h-full">
            
            <UPageGrid>
                
                <ContentRenderer
                    class="col-span-5"
                    :class="page?.meta.align === 'right' ? 'lg:col-start-8' : ''"
                    v-if="page"
                    :value="page"/>
            </UPageGrid>
        </UContainer>
    </section>   
</template>

<script setup lang="ts">

import { unref } from 'vue'
import { useRuntimeConfig } from '#app'

const config = useRuntimeConfig()

const props = defineProps({
    page: {
        type: Object,
        default: null
    }
});

const page = computed(() => unref(props.page))

const bgImageUrl = computed(() => {

    return page.value?.image
        ? toTwicpicBgUrl(page.value.image + '?deployment=' + config.public.appVersion, false)
        : undefined
})




</script>
